









import VueOptions from '@utils/VueOptions'
import Navbar from './components/Navbar'
import ProgressBarsWindow from '@ui/ProgressBars/ProgressBarsWindow'

settings =
  vue:
    components: { Navbar, ProgressBarsWindow }
    created: -> @ensureNoMember()
    mounted: -> @navigateToDashboard() if @$route.name is 'Dashboard'

export default VueOptions.vue settings
